import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_TICKETNOTIFICATION } from "../../../utils/constants";
import { NotificationInterface } from "../../../models/notification";
import notificationService from "../../../services/notificationService";

interface UpdateNotificationContext {
  previousNotification: NotificationInterface[];
}

const useUpdateTicketNotif = () => {
  const queryClient = useQueryClient();

  return useMutation<
    NotificationInterface,
    Error,
    NotificationInterface,
    UpdateNotificationContext
  >({
    mutationFn: async (notification: NotificationInterface) => {
      return notificationService.MarkNotificationRead(notification.id);
    },

    onMutate: async (updated: NotificationInterface) => {
      await queryClient.cancelQueries({
        queryKey: [CACHE_KEY_TICKETNOTIFICATION],
      });

      const previousNotification =
        queryClient.getQueryData<NotificationInterface[]>([
          CACHE_KEY_TICKETNOTIFICATION,
        ]) || [];

      queryClient.setQueryData<NotificationInterface[]>(
        [CACHE_KEY_TICKETNOTIFICATION],
        (notifications = []) =>
          notifications.filter((notification) => notification.id !== updated.id)
      );

      return { previousNotification };
    },

    onSuccess: (savedNotification) => {
      queryClient.setQueryData<NotificationInterface[]>(
        [CACHE_KEY_TICKETNOTIFICATION],
        (notifications) =>
          notifications?.filter(
            (notification) => notification.id !== savedNotification.id
          )
      );
    },

    onError: (error, updatedNotification, context) => {
      if (!context) return;

      queryClient.setQueryData<NotificationInterface[]>(
        [CACHE_KEY_TICKETNOTIFICATION],
        context.previousNotification
      );
    },
  });
};

export default useUpdateTicketNotif;
